import React, { Component } from 'react';
import './concept-detail.scss';
import { Constants, ImageConstants } from '../../../../constants/constants';
import { getImageSource } from '../../../../utility/image-source'
import HomeworkApi from '../../../../apis/homework'

class ConceptDetail extends Component {

    state = {
    }

    componentDidMount() {
        // this.getChapterHierarchy()

        this.state.conceptsInfo = this.props.conceptsInfo
        this.state.title = this.props.chapterTitle
        this.state.conceptsName = this.props.conceptTitles
    }


    expand = (item, index) => {
        let homeworkList = this.state.homeworkList
        homeworkList[index].expand = !homeworkList[index].expand
        this.setState({ homeworkList })
    }

    onClickTab = (index) => {
        this.setState({ activeTabIndex: index })
    }

    onClickBack = () => {
        this.props.back()
    }

    onClickInfo = () => {
        this.setState({ showInfoModal: true })
    }

    hideInfoModal = () => {
        this.setState({ showInfoModal: false })
    }

    getColor(skill) {
        if (!skill) {
            return
        }
        skill = skill.toUpperCase()
        let colors = Constants.SKILLS_COLOR
        let color = colors[skill]
        return color
    }

    onChangeHandler = (event, key) => {

        let text = event?.target?.value
        this.setState({ [key]: text }, () => {

            if (text.length == 0) {
                this.setState({ showSearchResults: false })
            }

            if (text && text.length > 2) {
                this.getChapterDetailWithFilters(text)
            }

        })
    }

    getChapterDetailWithFilters = (text) => {
        let payload = {
            chapterKey: this.props.chapterKey,
            searchText: text,
            class: this.props?.payload?.class
        }

        let validate = this.validatePayload(payload)
        if (!validate) return

        HomeworkApi.getChapterHierarchyWithFilters(payload)
            .then(response => {
                this.setState({ searchResults: [] }, () => {
                    this.setState({ searchResults: response.chapter, showSearchResults: true }, () => {
                        this.searchHtmlPage(text)
                    })
                })
            }).catch(err => {
            })
    }

    validatePayload(payload = {}) {
        if (!payload.chapterKey || !payload.class) return false
        return true

    }

    searchHtmlPage(text) {
        if (text.length) {
            let regExp = new RegExp(text, "gi")
            this.setState({ reload: true }, () => {
                this.setState({ reload: false }, () => {
                    let inputText = document.getElementsByTagName("p");
                    for (let i = 0; i < inputText.length; i++) {
                        let innerHTML = inputText[i].innerHTML
                        innerHTML = innerHTML.replace(regExp, function (str) {
                            return `<span class='highlight'>${str}</span>`
                        })
                        inputText[i].innerHTML = innerHTML;
                    }

                    // this.scollIntoView(inputText[0].getAttribute("id"))
                })
            })
        } else if (!text) {
            this.setState({ reload: true }, () => {
                this.setState({ reload: false })
            })
        }
    }

    renderStudentCard = (student) => {
        return (
            <div className="cw-card student p-4 ">
                <div className=" flex">
                    <div className="profile-avatar text-center mr-2 d-inline-block">
                        <div className="row justify-content-center">
                            <img className="" alt="img" src={student?.image} />
                        </div>
                    </div>
                    <div className="pl-2 d-inline-block">
                        <div className="student-name">{student?.name}</div>
                        <div className="student-roll-number">Roll no - {student?.rollNumber}</div>
                    </div>
                </div>
            </div>
        )
    }

    renderList = () => {
        return (
            this.state.conceptsInfo?.map((concept, index) => (

                <div className="concept-wrapper">
                    <div className="concept-index">Concept {index + 1}</div>
                    <div className="concept-title pt-2">{concept?.title}</div>
                    <div >
                        {
                            concept.elos.map((elo, levelIndex) => (
                                <div>
                                    <div className="elo-index pt-4">Level {levelIndex + 1} </div>
                                    {
                                        elo.map(item => (
                                            <div className="row pt-3 ml-3">
                                                <div className="col-10 elo-title"><span className='mr-2'>•</span>{item?.title}</div>
                                                <div className="col-2 my-auto text-center"><div className="skill px-2 py-1" style={{ background: this.getColor(item?.skill) }}>{item?.skill}</div></div>
                                            </div>
                                        ))
                                    }
                                </div>
                            ))

                        }
                    </div>
                </div>
            ))
        )
    }

    onClickDeleteText = () => {
        this.setState({ search: "", showSearchResults: false })
    }

    render() {
        return (

            <div className='concept-detail'>

                <div className="abs-image">
                    <img className='cursor-pointer header-image' src={getImageSource(ImageConstants.HEADER1)} />
                </div>


                <>
                    <div className="row pt-4">
                        <div className="col-10">
                            <div className="row m-0 search">
                                <div className="col-10">
                                    <input className={`search-input`} placeholder='Search'
                                        value={this.state.search}
                                        onChange={(e) => this.onChangeHandler(e, 'search')} />
                                </div>
                                {
                                    this.state.search && this.state.search.length ?
                                        <div className="col-2 my-auto text-right"><img className='search-icon cursor-pointer' src={getImageSource(ImageConstants.CROSS)} onClick={() => this.onClickDeleteText()} /></div>
                                        :
                                        <div className="col-2 my-auto text-right"><img className='search-icon cursor-pointer' src={getImageSource(ImageConstants.SEARCH)} /></div>
                                }
                            </div>
                        </div>
                        <div className="col-2 my-auto"><img className='close-icon cursor-pointer' src={getImageSource(ImageConstants.CROSS)} onClick={() => this.onClickBack()} /></div>
                    </div>
                    <div>
                        {
                            this.state.showSearchResults ?
                                this.state.searchResults && this.state.searchResults.length ? this.state.searchResults.map((item, index) =>
                                    <>
                                        <div className="level-search-index pt-4">Level {item.level} </div>
                                        <div className="row pt-2">
                                            <div className="col-10 elo-title"><p>{item?.title}</p></div>
                                            <div className="col-10 concept-index">{item?.conceptTitle}</div>
                                        </div>
                                    </>
                                )
                                    :
                                    <div className='text-center pt-5'>No results found</div>

                                :

                                this.state.conceptsInfo && this.state.conceptsInfo.length ?
                                    <>

                                        <div className="chapter-wrapper">
                                            <div className="row">
                                                <div className="col-9"><span className="concept-title">{this.state.title} </span></div>
                                                {/* <div className="col-3">
                                        <div className="cw-card text-center">
                                            <img className='action-image cursor-pointer m-2' src={getImageSource(ImageConstants.EXCEL_ICON)} />
                                            <img className='action-image cursor-pointer m-2' src={getImageSource(ImageConstants.PDF)} />
                                            <img className='action-image cursor-pointer m-2' src={getImageSource(ImageConstants.PRINT)} />
                                        </div>
                                    </div> */}
                                            </div>

                                            <div className="pt-4">
                                                <div className="concept-index">Concepts</div>
                                                <div className="">
                                                    {
                                                        this.state.conceptsName.map(chapter => (
                                                            <div className="chapter-name pt-2">{chapter} </div>
                                                        ))
                                                    }</div>
                                            </div>
                                        </div>

                                        <div>
                                            {this.renderList()}
                                        </div>
                                    </>
                                    :
                                    <div className='text-danger pt-4'><strong>Please select a chapter</strong></div>
                        }
                    </div>
                </>

            </div>

        );
    }
}

export default ConceptDetail;